import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import {
  Tenant,
  TenantHomeUpdateModel,
} from 'app/state/tenants.repository';
import { TenantsService } from 'app/state/tenants.service';
import { Observable } from 'rxjs';
import { TrackRender } from 'app/shared/front-perfomance';
import { ToastService, MessageText } from 'app/helpers/services/toastService';

@TrackRender()
@Component({
    selector: 'app-tenant-edithtml-page',
    templateUrl: './tenant-edithtml-page.component.html',
    styleUrls: ['./tenant-edithtml-page.component.scss'],
    standalone: false
})
export class TenantEdithtmlPageComponent implements OnChanges {
  @Input() tenant: Tenant | null = null;
  @Input() id: string | null = null;
  submitErrors: string[] | null = null;

  editTenantModel!: TenantHomeUpdateModel;

  constructor(
    private service: TenantsService,
    private toastService: ToastService,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tenant'] && this.tenant) {
      this.editTenantModel = {
        logo: this.tenant.homePageMediaFile ?? undefined,
        pageHtml: this.tenant.pageHtml ?? '',
        videoUrl: this.tenant.videoUrl ?? '',
        pageHtml2: this.tenant.pageHtml2 ?? '',
        descriptionMobile: this.tenant.descriptionMobile ?? '',
        headline: this.tenant.headline ?? '',
      };
    }
  }

  update(tenantModel: TenantHomeUpdateModel) {
    let updateResult: Observable<Tenant> | undefined;
    if (this.id) {
      updateResult = this.service.updateTenantContent(this.id, tenantModel);
    }
    if (updateResult) {
      updateResult.subscribe({
        complete: () => {
          this.toastService.showSuccess(MessageText.saved);
        },
        error: (data) => (this.submitErrors = data),
      });
    }
  }
}
